var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoCoreMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hex-shape",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 50.015167 -0.00016 L 93.030655 24.825249 L 93.030655 74.476044 L 50.015167 99.320999 L 7.018764 74.476044 L 7.018764 24.825249 L 50.015167 -0.00016 Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "hex-icon",
    transform: "translate(25,25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37 6 C 34.256343 6 32 8.256343 32 11 L 32 39 C 32 41.743657 34.256343 44 37 44 C 39.743657 44 42 41.743657 42 39 L 42 11 C 42 8.256343 39.743657 6 37 6 z M 37 9 C 38.122343 9 39 9.877657 39 11 L 39 39 C 39 40.122343 38.122343 41 37 41 C 35.877657 41 35 40.122343 35 39 L 35 11 C 35 9.877657 35.877657 9 37 9 z M 24 16 C 21.256343 16 19 18.256343 19 21 L 19 39 C 19 41.743657 21.256343 44 24 44 C 26.743657 44 29 41.743657 29 39 L 29 21 C 29 18.256343 26.743657 16 24 16 z M 11 26 C 8.256343 26 6 28.256343 6 31 L 6 39 C 6 41.743657 8.256343 44 11 44 C 13.743657 44 16 41.743657 16 39 L 16 31 C 16 28.256343 13.743657 26 11 26 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCoreMedium);
export default __webpack_public_path__ + "static/media/no-core-medium.f7a90283f65514c5b99ea4fe0b3e08a9.svg";
export { ForwardRef as ReactComponent };